import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { PropTypes } from 'prop-types';
import React from 'react';

import Facebook from '../../../assets/svg/facebook.svg';
import LinkedIn from '../../../assets/svg/linkedin.svg';
import Twitter from '../../../assets/svg/twitter.svg';
import StoryShimCursor from './StoryShimCursor';

const StoryIntro = ({ data, location }) => {
  const { image, storyHeader = '', subHeader = '' } = data;
  return (
    <div className="story__intro" title="intro">
      <StoryShimCursor />
      <div className="story__intro--animation-shim-in" />
      <div className="story__intro--animation-shim-out" />
      <div className="story__intro--text">
        <h1 className="header">{storyHeader}</h1>
        <h3 className="sub-header">{subHeader}</h3>
        <div className="social-media">
          <a
            data-tracking-event="share"
            data-tracking-method="Facebook"
            href={`https://www.facebook.com/sharer/sharer.php?u=${location.href}`}
            rel="noreferrer"
            target="_blank"
          >
            <Facebook />
          </a>
          <a
            data-tracking-event="share"
            data-tracking-method="Twitter"
            href={`http://twitter.com/share?url=${location.href}`}
            rel="noreferrer"
            target="_blank"
          >
            <Twitter />
          </a>
          <a
            data-tracking-event="share"
            data-tracking-method="LinkedIn"
            href={`https://www.linkedin.com/shareArticle?mini=true&url=${location.href}`}
            rel="noreferrer"
            target="_blank"
          >
            <LinkedIn />
          </a>
        </div>
      </div>
      <div className="story__intro--image">
        <GatsbyImage image={getImage(image)} style={{ height: '100%' }} />
      </div>
    </div>
  );
};

StoryIntro.propTypes = {
  data: PropTypes.object,
  location: PropTypes.object,
};

export default StoryIntro;
